import { useId, useState } from 'react';
import { usePeriod } from '../context/PeriodContext';
import { formatPeriod } from '../format';
import { MOVIL, useMediaQuery } from '../hooks/useMediaQuery';

/** Selector de periodo global: presets rapidos + rango a medida. */
export function PeriodPicker(): JSX.Element {
  const { period, setPeriod, presets } = usePeriod();
  const presetId = useId();
  const startId = useId();
  const endId = useId();

  const active =
    presets.find((p) => p.period.start === period.start && p.period.end === period.end)?.id ??
    'custom';

  // En movil, las dos fechas exactas ocupan media pantalla antes de que se vea
  // un solo numero. Se pliegan: con un preset elegido no hacen falta, y si
  // alguien quiere un rango a medida, se despliegan.
  const esMovil = useMediaQuery(MOVIL);
  const [fechasAbiertas, setFechasAbiertas] = useState(false);
  const mostrarFechas = !esMovil || fechasAbiertas || active === 'custom';

  return (
    <div className="period">
      <div className="period__group">
        <label className="period__label" htmlFor={presetId}>
          Periodo
        </label>
        <select
          id={presetId}
          className="input input--compact"
          value={active}
          onChange={(event) => {
            const preset = presets.find((p) => p.id === event.target.value);
            if (preset) setPeriod(preset.period);
          }}
        >
          {presets.map((preset) => (
            <option key={preset.id} value={preset.id}>
              {preset.label}
            </option>
          ))}
          <option value="custom">Rango personalizado</option>
        </select>
      </div>

      {esMovil && active !== 'custom' && (
        <button
          type="button"
          className="btn btn--link btn--sm period__toggle"
          aria-expanded={fechasAbiertas}
          onClick={() => setFechasAbiertas((v) => !v)}
        >
          {fechasAbiertas ? 'Ocultar fechas' : 'Ajustar fechas'}
        </button>
      )}

      {mostrarFechas && (
      <>
      <div className="period__group">
        <label className="period__label" htmlFor={startId}>
          Desde
        </label>
        <input
          id={startId}
          type="date"
          className="input input--compact"
          value={period.start}
          max={period.end}
          onChange={(event) =>
            setPeriod({ ...period, start: event.target.value || period.start })
          }
        />
      </div>

      <div className="period__group">
        <label className="period__label" htmlFor={endId}>
          Hasta
        </label>
        <input
          id={endId}
          type="date"
          className="input input--compact"
          value={period.end}
          min={period.start}
          onChange={(event) => setPeriod({ ...period, end: event.target.value || period.end })}
        />
      </div>
      </>
      )}

      <p className="period__summary" aria-live="polite">
        {formatPeriod(period.start, period.end)}
      </p>
    </div>
  );
}
